import React from 'react';
import { Button, Table, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { FaCheck, FaTimes, FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';

const InquiriesTable = ({ data, onAccept, onReject }) => {
  
  const renderTooltip = (props, text) => (
    <Tooltip id="button-tooltip" {...props}>
      {text}
    </Tooltip>
  );

  return (
    <div className="table-responsive">
      <Table hover size="sm" className="align-middle text-nowrap mb-0">
        <thead className="table-light">
          <tr>
            <th style={{ width: '25%' }}>Entity / Date</th>
            <th style={{ width: '20%' }}>Contact Person</th>
            <th style={{ width: '25%' }}>Contact Details</th>
            <th style={{ width: '20%' }}>Location</th>
            <th className="text-end" style={{ width: '10%' }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {data && data.length > 0 ? (
            data.map((row) => (
              <tr key={row.inquiry_id}>
                {/* 1. Entity Name + Date */}
                <td>
                  <div className="fw-bold text-dark text-truncate" style={{ maxWidth: '200px' }} title={row.entity_name}>
                    {row.entity_name}
                  </div>
                  <small className="text-muted" style={{ fontSize: '0.8rem' }}>
                    {new Date(row.created_at).toLocaleDateString('en-IN', {
                      day: '2-digit',
                      month: 'short',
                      year: '2-digit',
                    })}
                  </small>
                </td>

                {/* 2. Contact Person (Primary + Secondary) */}
                <td>
                  <div className="fw-semibold">{row.primary_person_name}</div>
                  {row.secondary_person_name && (
                    <small className="text-muted d-block text-truncate" style={{ maxWidth: '150px' }}>
                      Alt: {row.secondary_person_name}
                    </small>
                  )}
                </td>

                {/* 3. Contact Info (Mobile + Email) */}
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <FaPhone size={10} className="text-secondary" /> 
                    <span>{row.primary_person_mobile_no}</span>
                  </div>
                  <div className="d-flex align-items-center gap-2 text-muted small">
                    <FaEnvelope size={10} /> 
                    <span className="text-truncate" style={{ maxWidth: '180px' }} title={row.primary_person_email_id}>
                      {row.primary_person_email_id}
                    </span>
                  </div>
                </td>

                {/* 4. Location */}
                <td>
                  <div className="d-flex align-items-start gap-1">
                    <FaMapMarkerAlt size={12} className="mt-1 text-secondary" />
                    <div>
                        <span>{row.city}, {row.state}</span>
                        <br/>
                        <small className="text-muted">{row.pincode}</small>
                    </div>
                  </div>
                </td>

                {/* 5. Actions */}
                <td className="text-end">
                  <div className="d-flex justify-content-end gap-2">
                    <OverlayTrigger placement="top" overlay={(p) => renderTooltip(p, "Accept & Create Admin")}>
                        <Button
                        variant="success"
                        size="sm"
                        className="px-2 py-1"
                        onClick={() => onAccept(row)}
                        >
                        <FaCheck />
                        </Button>
                    </OverlayTrigger>

                    <OverlayTrigger placement="top" overlay={(p) => renderTooltip(p, "Reject Inquiry")}>
                        <Button
                        variant="outline-danger"
                        size="sm"
                        className="px-2 py-1"
                        onClick={() => onReject(row.inquiry_id)}
                        >
                        <FaTimes />
                        </Button>
                    </OverlayTrigger>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center py-5 text-muted">
                <div className="d-flex flex-column align-items-center">
                    <i className="bi bi-inbox fs-1 mb-2"></i>
                    No pending partner inquiries found.
                </div>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default InquiriesTable;